const PLACEHOLDER_MARKER = 'avatars/placeholder/';
const SENTINEL = 'string';

export function isBlankText(value) {
    if (value === null || value === undefined) return true;
    const text = String(value).trim();
    return text === '' || text.toLowerCase() === SENTINEL;
}

export function isPlaceholderAvatar(avatar) {
    return typeof avatar === 'string' && avatar.includes(PLACEHOLDER_MARKER);
}

export function hasOwnAvatar(avatar) {
    return typeof avatar === 'string'
        && avatar.trim() !== ''
        && !isPlaceholderAvatar(avatar);
}

export function hasAnyAvatar(avatar) {
    return typeof avatar === 'string' && avatar.trim() !== '';
}

export function monogramOf(name) {
    const source = String(name ?? '').trim();
    if (!source) return '?';
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
        const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
        for (const part of segmenter.segment(source)) {
            return part.segment;
        }
    }
    return Array.from(source)[0];
}

export function avatarTintVar(id) {
    const match = String(id ?? '').replace(/-/g, '').match(/^[0-9a-fA-F]{1,8}/);
    const parsed = match ? parseInt(match[0], 16) : 0;
    const index = (Number.isFinite(parsed) ? parsed : 0) % 6;
    return `var(--pl-avatar-tint-${index + 1})`;
}

export function duplicatedAvatars(characters) {
    const seen = new Set();
    const shared = new Set();
    for (const character of characters ?? []) {
        const url = character?.biography?.avatar;
        if (!url) continue;
        if (seen.has(url)) shared.add(url);
        else seen.add(url);
    }
    return shared;
}

export function hasUnusableName(name) {
    const text = String(name ?? '').trim();
    return isBlankText(text) || /^unnamed/i.test(text);
}

export function isIncomplete(character) {
    if (!character) return true;
    const biography = character.biography;
    return hasUnusableName(character.name)
        || !biography
        || isBlankText(biography.background)
        || isBlankText(biography.appearance)
        || !character.path;
}

export function publicationStateOf(character) {
    const publication = character?.publication;
    if (!publication) return 'none';
    const open = publication.open_request;
    const pending = open && open.status === 'pending';
    if (publication.is_public && pending) return 'edit-pending';
    if (pending) return 'pending';
    if (publication.is_public) return 'published';
    if (open && open.status === 'draft') return 'draft';
    return 'none';
}

export function searchTextOf(character) {
    const parts = [
        character?.name,
        character?.path?.name,
        character?.rank?.name,
        Array.isArray(character?.tags) ? character.tags.join(' ') : '',
        character?.biography?.background,
    ];
    return parts.filter(Boolean).join(' ').toLowerCase();
}
